import { format, parseISO } from "date-fns";
import pt from "date-fns/locale/pt-BR";

export const formatDefaultDate = (isoDate) => {
  return format(parseISO(isoDate), "dd/MM/yyyy", { locale: pt });
};

export const formatDayMonth = (isoDate) => {
  return format(parseISO(isoDate), "dd MMM", { locale: pt });
};
